import React, { FC } from 'react';
import { PortalDialog } from '@component/Portal';
import { Modal } from '@app/react/uikit/Modal';

export interface PartsResetConfirmDialogProps {
    show: boolean;
    btnChangeProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
    btnNochangeProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
}

export const PartsResetConfirmDialog: FC<PartsResetConfirmDialogProps> = (
    props,
) => {
    const { show, btnChangeProps, btnNochangeProps, title, description } = props;

    return (
        <PortalDialog className="shaft-change-nock-yaziri-dialog">
            <Modal show={show} setShow={() => false}>
                <span className="title">{title}</span>
                <p>
                    {description}
                </p>
                <div className="footer">
                    <button type="button" className="change" {...btnChangeProps}>
                        変更する →
                    </button>
                    <button type="button" className="no-change" {...btnNochangeProps}>
                        キャンセル
                    </button>
                </div>
            </Modal>
        </PortalDialog>
    );
};
